<template>
	<component
		:is="radioButtonWrap"
		:gap="gap"
	>
		<KkOptionItem
			:id="uniqueId"
			:input-position="radioPosition"
			:icon-position="optionIconPosition"
			:size="radioSize"
			:label="label"
			:description="description"
			:icon-name="iconName"
			:is-disabled="disabled"
			:image-src="imageSrc"
			:image-alt="imageAlt"
		>
			<template #input>
				<div
					:class="[
						'kk-radio-button-item__radio-button',
						`kk-radio-button-item__radio-button--${radioSize}`,
						`kk-radio-button-item__radio-button--${radioPosition}`
					]"
				>
					<KkRadioButton
						:id="uniqueId"
						:ref="uniqueId"
						v-model="model"
						:input-value="inputValue"
						:is-disabled="disabled"
					/>
				</div>
			</template>
			<template #footer>
				<slot name="footer" />
			</template>
		</KkOptionItem>
		<div
			v-if="$slots.collapse"
			v-show="isChecked"
			class="kk-radio-button-collapse"
			:class="{
				'kk-radio-button-collapse__open': isChecked
			}"
		>
			<slot name="collapse" />
		</div>
	</component>
</template>

<script>
import LayoutList from '../../../layouts/LayoutList.vue'
import KkOptionItem from '../../KkOptionItem';
import KkRadioButton from '../../KkRadioButton';
import { uniqueId } from 'lodash-es';

export const RADIO_BUTTON_ITEM_SIZE_LIST = [
	'md',
	'lg',
];

export const ICON_POSITION_LIST = [
	'left',
	'right',
];

export default {
	name: 'KkRadioButtonItem',
	components: {
		LayoutList,
		KkOptionItem,
		KkRadioButton
	},
	props: {
		value: {
			type: [String, Number, Boolean],
			default: null,
		},
		inputValue: {
			type: [String, Number, Boolean],
			default: null,
		},
		label: {
			type: String,
			default: null,
			required: '',
		},
		description: {
			type: String,
			default: '',
		},
		radioPosition: {
			type: String,
			default: 'left',
		},
		size: {
			type: String,
			default: 'md',
			validator: val => RADIO_BUTTON_ITEM_SIZE_LIST.indexOf(val) !== -1,
		},
		isDisabled: {
			type: Boolean,
			default: false,
		},
		iconName: {
			type: String,
			default: '',
		},
		iconPosition: {
			type: String,
			default: 'left',
			validator: val => ICON_POSITION_LIST.indexOf(val) !== -1,
		},
		imageSrc: {
			type: String,
			default: '',
		},
		imageAlt: {
			type: String,
			default: '',
		},
		gap: {
			type: [String, Number],
			default: 3,
		}
	},
	computed: {
		isGroup() {
			let parent = this.$parent;
			while (parent) {
				if (parent.$options.name !== 'KkRadioButtonGroup') {
					parent = parent.$parent;
				} else {
					// eslint-disable-next-line vue/no-side-effects-in-computed-properties
					this._radioGroup = parent;
					return true;
				}
			}
			return false;
		},
		uniqueId() {
			return uniqueId('kk-radio-button-item');
		},
		optionIconPosition() {
			switch (this.radioPosition) {
				case 'right':
					return this.iconPosition;
				case 'left':
				default:
					return 'top-right';
			}
		},
		radioSize() {
			if (this.isGroup && this._radioGroup?.size) {
				return this._radioGroup?.size
			}

			return this.size;
		},
		disabled() {
			if (this.isGroup && this._radioGroup?.isDisabled) {
				return this._radioGroup?.isDisabled
			}

			return this.isDisabled;
		},
		isChecked() {
			return this.inputValue === this.model;
		},
		radioButtonWrap() {
			return this.$slots.collapse ? 'LayoutList' : 'div';
		},
		model: {
			get() {
				return this.isGroup ? this._radioGroup.value : this.value;
			},
			set(val) {
				if (this.isGroup) {
					this._radioGroup.$emit.call(this._radioGroup, 'input', val);
				} else {
					this.$emit('input', val);
				}
			}
		},
	},
};
</script>
